module.exports = __webpack_public_path__ + "static/phil-615045e0867bb7fc01def7f19c044a17.jpg";